// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"6e3a73d4","368":"14d05bbc","699":"28b9d379","894":"fc0d3779","938":"db4cda0c"}[chunkId] + ".css";
};